var FilterModule = /** @class */ (function () {
    function FilterModule() {
    }
    return FilterModule;
}());
export { FilterModule };
